import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import CheckboxGroup from "../../../core/CheckboxGroup";
import styles from "./index.module.scss";


const BatchDownloadDialog: React.FC<BatchDownloadDialogProps> = (props: BatchDownloadDialogProps) => {
  const { open, onClose, onSave } = props;
  const [pdf, setPdf] = React.useState<boolean>(true);
  const [excel, setExcel] = React.useState<boolean>(true);


  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="lg">
      <DialogTitle sx={{ fontWeight: 700, fontSize: "24px", padding: "40px 40px 60px" }}>
        請求書一括ダウンロード
      </DialogTitle>
      <DialogContent sx={{ padding: "0 40px 24px" }}>
        <div className={styles.descriptions}>確定済の請求書をダウンロードします。</div>
        <div className={styles.checbox_group}>
            <div>請求ステータス</div>
            <div>
                <CheckboxGroup checked={excel} onChange={() => setExcel(!excel)} label="Excel"/>
                <CheckboxGroup checked={pdf} onChange={() => setPdf(!pdf)} label="PDF"/>
            </div>
        </div>
        <div className={styles.functions}>
          <Button variant="outlined" onClick={() => onClose()}>キャンセル</Button>
          <Button variant="contained" onClick={() => onSave(pdf, excel)}>ダウンロード</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default BatchDownloadDialog;

export type BatchDownloadDialogProps = {
  open: boolean,
  onClose: () => void,
  onCancel?: () => void,
  onSave: (pdf: boolean, excel: boolean) => void
}